import React, { useState } from "react";
import { products } from "../mock/products";
import { useParams } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { Helmet } from "react-helmet";
import { slugify } from "./shared/Globals";

const SingleProduct = () => {
  const params = useParams();

  const product = products.filter(
    (product) => product.id === parseInt(params.productId)
  );

  const [selectedImage, setSelectedImage] = useState(product[0].images[0]);

  return (
    <>
      <Helmet>
        <title>{product[0].title}</title>
        <meta name="title" content={`${product[0].title} | YourBrand`} />
        <meta name="description" content={product[0].details.slice(0, 160)} />
        <link
          rel="canonical"
          href={`https://sunkisseddelight.com/products/${slugify(
            product[0].title
          )}`}
        />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="product" />
        <meta
          property="og:url"
          href={`https://sunkisseddelight.com/products/${slugify(
            product[0].title
          )}`}
        />
        <meta property="og:title" content={`${product[0].title} | YourBrand`} />
        <meta
          property="og:description"
          content={product[0].details.slice(0, 160)}
        />
        <meta property="og:image" content={product[0].img} />
        <link rel="image_src" href={product[0].img} />
      </Helmet>
      <div
        id="qodef-page-inner"
        className="qodef-content-grid qodef-content--fullscreen"
      >
        <main
          id="qodef-page-content"
          className="qodef-grid qodef-layout--template qodef--no-bottom-space"
        >
          <div className="qodef-grid-inner clear">
            <div
              id="qodef-woo-page"
              className="qodef-grid-item qodef--single qodef-popup--magnific-popup qodef-magnific-popup qodef-popup-gallery"
            >
              <div
                id="product-4800"
                className="product type-product post-4800 status-publish first instock product_cat-chocobar product_tag-cakes product_tag-tarts has-post-thumbnail shipping-taxable purchasable product-type-simple"
              >
                <div className="qodef-content-grid">
                  <div className="qodef-woo-single-inner">
                    <div className="qodef-woo-single-image">
                      <div
                        className="woocommerce-product-gallery woocommerce-product-gallery--with-images woocommerce-product-gallery--columns-4 images qodef-position--left"
                        data-columns={4}
                        style={{
                          opacity: 1,
                          transition: "opacity 0.25s ease-in-out 0s",
                        }}
                      >
                        <figure className="woocommerce-product-gallery__wrapper">
                          <div
                            data-thumb={selectedImage}
                            data-thumb-alt="v"
                            className="woocommerce-product-gallery__image"
                          >
                            <LazyLoadImage
                              alt={selectedImage}
                              width={300}
                              height={344}
                              effect="blur"
                              wrapperProps={{
                                // If you need to, you can tweak the effect transition using the wrapper style.
                                style: { transitionDelay: "1s" },
                              }}
                              src={selectedImage}
                            />
                          </div>
                          <div className="qodef-woo-thumbnails-wrapper">
                            {product[0].images.map((img, i) => (
                              <div
                                data-thumb={img}
                                data-thumb-alt="d"
                                className="woocommerce-product-gallery__image prod_img"
                                onClick={() => setSelectedImage(img)}
                              >
                                <LazyLoadImage
                                  alt={img}
                                  width={300}
                                  height={344}
                                  effect="blur"
                                  wrapperProps={{
                                    // If you need to, you can tweak the effect transition using the wrapper style.
                                    style: { transitionDelay: "1s" },
                                  }}
                                  src={img}
                                />
                              </div>
                            ))}
                          </div>{" "}
                        </figure>
                      </div>
                    </div>
                    <div className="summary entry-summary">
                      <h3 className="qodef-woo-product-title product_title entry-title">
                        {product[0].title}
                      </h3>
                      <p className="price">
                        <span className="woocommerce-Price-amount amount">
                          <bdi>
                            {product[0].id === 4 || product[0].id === 3 ? (
                              <h4
                                dangerouslySetInnerHTML={{
                                  __html: `${product[0].price}`,
                                }}
                              ></h4>
                            ) : (
                              <h4
                                dangerouslySetInnerHTML={{
                                  __html: `${product[0].price} (Including all taxes)`,
                                }}
                              ></h4>
                            )}
                          </bdi>
                        </span>
                      </p>

                      <p>{product[0].details}</p>

                      <p>
                        <i>
                          Each box contains 4 chocolates, individually wrapped
                          in elegant gold foil — designed for freshness,
                          hygiene, and delight in every dose.
                        </i>
                      </p>

                      <p>
                        <b>
                          {" "}
                          Here’s a general guideline to help you estimate your
                          daily Vitamin D requirement
                        </b>
                      </p>
                      <table border="1">
                        <tr>
                          <th>Age Group / Condition</th>
                          <th>Suggested Daily IU</th>
                        </tr>
                        <tr>
                          <td>Children (5–12 years)</td>
                          <td>600 – 1000 IU</td>
                        </tr>
                        <tr>
                          <td>Teens & Adults (13 – 70 years)</td>
                          <td>1000 IU</td>
                        </tr>
                        <tr>
                          <td>70 plus</td>
                          <td>1000 – 1500 IU</td>
                        </tr>
                        <tr>
                          <td>Pregnant or Lactating Women</td>
                          <td>1000 IU – 2000 IU</td>
                        </tr>
                        <tr>
                          <td>People with Deficiency (as advised)</td>
                          <td>As recommended by doctor</td>
                        </tr>
                      </table>
                      {product[0].id === 4 || product[0].id === 3 ? (
                        <></>
                      ) : (
                        <>
                          <br />
                          <a href={`/checkout/` + product[0].id}>
                            <button
                              type="submit"
                              value={4800}
                              className="btn-shop"
                            >
                              Buy Now
                            </button>
                          </a>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <div className="qodef-content-grid">
                  <section className="related products">
                    <h2>Related products</h2>
                    <div className="qodef-woo-product-list qodef-item-layout--info-below qodef-hover--move">
                      <ul className="products columns-4">
                        {products.map((p, i) =>
                          p.id === parseInt(params.productId) ? null : (
                            <>
                              <li className="product type-product post-4115 status-publish first instock product_cat-chocolate product_cat-hot-choco product_tag-cakes product_tag-cannoli has-post-thumbnail shipping-taxable purchasable product-type-simple">
                                <div className="qodef-woo-product-inner">
                                  <div className="qodef-woo-product-image">
                                    <img
                                      width={800}
                                      height={800}
                                      src={p.img}
                                      className="attachment-woocommerce_thumbnail size-woocommerce_thumbnail"
                                      alt="x"
                                      decoding="async"
                                      loading="lazy"
                                      srcSet={p.img}
                                      sizes="auto, (max-width: 800px) 100vw, 800px"
                                    />
                                  </div>
                                  <div className="qodef-woo-product-content">
                                    <h4 className="qodef-woo-product-title woocommerce-loop-product__title">
                                      {p.title}
                                    </h4>
                                    <div className="qodef-woo-product-categories">
                                      {p.header}
                                    </div>
                                    <span className="price">
                                      <span className="woocommerce-Price-amount amount">
                                        <b
                                          dangerouslySetInnerHTML={{
                                            __html: p.price,
                                          }}
                                        >
                                          {}
                                        </b>
                                      </span>
                                    </span>
                                  </div>
                                  <a
                                    href={
                                      `/product/` +
                                      p.id +
                                      `/${slugify(p.title)}`
                                    }
                                    className="woocommerce-LoopProduct-link woocommerce-loop-product__link"
                                  >
                                    {" "}
                                  </a>
                                </div>
                              </li>
                            </>
                          )
                        )}
                      </ul>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default SingleProduct;
